import { render } from "./LocalsView.vue?vue&type=template&id=7c0f65c1&ts=true"
import script from "./LocalsView.vue?vue&type=script&lang=ts"
export * from "./LocalsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__